import React from 'react';

import { Button, Container, Icon, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { Webform } from '@uncinc/react-drupal-core';
import TableRender from '@uncinc/uncinc-react-kitchen-sink/dist/components/TableRender';

import './style.scss';

const DesignSystem = () => {
  return (
    <section className="DesignSystem">
      <div className="Paragraph">
        <Container>
          <h2>Spacers</h2>
          <div className="margins">
            <div className="margins__0" />
            <div className="margins__1">2px<span /></div>
            <div className="margins__2">4px<span /></div>
            <div className="margins__3">8px<span /></div>
            <div className="margins__4">12px<span /></div>
            <div className="margins__5">16px<span /></div>
            <div className="margins__6">20px<span /></div>
            <div className="margins__7">24px<span /></div>
            <div className="margins__8">32px<span /></div>
            <div className="margins__9">36px<span /></div>
            <div className="margins__10">48px<span /></div>
            <div className="margins__11">56px<span /></div>
            <div className="margins__12">64px<span /></div>
            <div className="margins__13">72px<span /></div>
            <div className="margins__14">96px<span /></div>
            <div className="margins__15">120px<span /></div>
            <div className="margins__16">144px<span /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div>
            <h1> h1 The quick brown fox jumps over the lazy dog</h1>
            <h2> h2 The quick brown fox jumps over the lazy dog</h2>
            <h3> h3 The quick brown fox jumps over the lazy dog</h3>
            <h4> h4 The quick brown fox jumps over the lazy dog</h4>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div className="text--large">
            <p>P text--large   The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="text--regular">
            <p>P text--regular  The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="text--small">
            <p>P text--small   The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="caption">
            <p>caption The quick brown fox jumps over the lazy dog</p>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div>
            <ul>
              <li>The quick brown fox jumps over the lazy dog and went shopping for another brown fox to jumps over the lazy dog</li>
              <li>The quick brown fox jumps over the lazy dog went shopping for another brown fox to jumps over the lazy dog</li>
              <li>The quick brown fox jumps over the lazy dog went shopping for another brown fox to jumps over the lazy dog </li>
            </ul>
            <p>Some more text</p>

            <ol>
              <li>The quick brown fox jumps over the lazy dog once</li>
              <li>The quick brown fox jumps over the lazy dog twice</li>
              <li>The quick brown fox jumps over the lazy dog thrice</li>
            </ol>
            <p>Some more text</p>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Base colors</h3>
          <div className="Colors">
            <div className="Colors__1" />
            <div className="Colors__2" />
            <div className="Colors__3" />
            <div className="Colors__4" />
            <div className="Colors__5" />
            <div className="Colors__6" />
            <div className="Colors__7" />
            <div className="Colors__8" />
            <div className="Colors__9" />
            <div className="Colors__10" />
            <div className="Colors__11" />
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Grid systeem</h3>
        </Container>
        <Container small>
          <h3>Small</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-4"><div className="column" /></div>
            <div className="col-4"><div className="column" /></div>
            <div className="col-4"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container medium>
          <h3>Medium</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-5"><div className="column" /></div>
            <div className="col-7"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Normal</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-5"><div className="column" /></div>
            <div className="col-7"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container large>
          <h3>Large</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-3"><div className="column" /></div>
            <div className="col-6"><div className="column" /></div>
            <div className="col-3"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container fluid>
          <h3>Fluid</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-8"><div className="column" /></div>
            <div className="col-4"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Table </h3>
          <TableRender
            element={
              <table>
                <thead>
                  {' '}
                  <tr>
                    {' '}
                    <th>City</th> <th>Country</th> <th>Population</th>{' '}
                    <th>Area (sq km)</th> <th>Cost of Living</th>{' '}
                    <th>Avg Temperature (°C)</th> <th>Happines Rate</th>{' '}
                  </tr>
                </thead>
                <tbody>
                  {' '}
                  <tr>
                    {' '}
                    <td>New York</td> <td>USA</td> <td>8,398,748</td> <td>789</td>{' '}
                    <td>High</td> <td>12.5</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>London</td> <td>UK</td> <td>8,136,000</td> <td>1,572</td>{' '}
                    <td>High</td> <td>10.2</td> <td>Low</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Tokyo</td> <td>Japan</td> <td>13,515,271</td> <td>2,194</td>{' '}
                    <td>Very High</td> <td>16.9</td> <td>Low</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Paris</td> <td>France</td> <td>2,140,526</td> <td>105</td>{' '}
                    <td>High</td> <td>11.4</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Beijing</td> <td>China</td> <td>21,542,000</td> <td>16,410</td>{' '}
                    <td>Moderate</td> <td>12.8</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Rome</td> <td>Italy</td> <td>2,873,494</td> <td>1,285</td>{' '}
                    <td>High</td> <td>15.2</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Cairo</td> <td>Egypt</td> <td>9,500,000</td> <td>606</td>{' '}
                    <td>Low</td> <td>24.5</td> <td>High</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Sydney</td> <td>Australia</td> <td>5,312,163</td> <td>1,637</td>{' '}
                    <td>High</td> <td>18.9</td> <td>Low</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Mumbai</td> <td>India</td> <td>20,668,076</td> <td>603</td>{' '}
                    <td>Low</td> <td>27.2</td> <td>High</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Rio de Janeiro</td> <td>Brazil</td> <td>6,747,815</td>{' '}
                    <td>1,221</td> <td>Moderate</td> <td>23.8</td> <td>High</td>{' '}
                  </tr>
                </tbody>
              </table>
            }
            mobileCardsBreakpoint={768}
          />
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div className="buttons">
            <h3>Buttons</h3>
            <Button className="Button--primary">Button<Icon name="arrow_forward" flair="outlined" /></Button>
            <Button className="Button--secondary"><Icon name="close" flair="outlined" /></Button>
            <Button className="Button--primary" href="/">Button with link<Icon name="arrow_forward" flair="outlined" /></Button>
            <Button className="Button--secondary" href="/"><Icon name="close" flair="outlined" /></Button>
            <Button className="Button--textual" href="/">Button textual<Icon name="arrow_forward" flair="outlined" /></Button>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div className="links">
            <h3>Links</h3>
            <WysiwygField html=" <p>The quick brown fox jumps over the <a href=/>inline</a> lazy dog</p>" />
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Icons</h3>
          <div className="icons">
            {/* material-icon-names */}
            <Icon name="arrow_forward" flair="outlined" />
            <Icon name="chevron_right" flair="outlined" />
            <Icon name="close" flair="outlined" />
            <Icon name="download" flair="outlined" />
            <Icon name="edit" flair="outlined" />
            <Icon name="filter_list" flair="outlined" />
            <Icon name="info" flair="outlined" />
            <Icon name="radio" flair="outlined" />
          </div>

          <div className="icons">
            {/* custom-icon-names */}
            <Icon name="uncinc_location_pin" />
            <Icon name="facebook" />
            <Icon name="instagram" />
            <Icon name="linkedin" />
            <Icon name="x" />
            <Icon name="youtube" />
          </div>

          <div className="icons">
            {/* old icon implementation
            see _icons for support */}
            <i className="icon icon-arrow" />
            <i className="icon icon-location-pin icon-orientation-left" />
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Form elements</h3>
          <div className="forms">
            {/* <Webform id="design_system" /> */}
          </div>
        </Container>
      </div>
    </section>
  );
};

export default DesignSystem;
